import React from "react"
import styled from "styled-components"
import TransitionGroup from "react-transition-group/CSSTransitionGroup"

import OptionButton from "../../common/components/OptionButton"
import QuestionReport from "./QuestionReport"

import { onResponse, onSubmit } from "../handlers"
import FreeForm from "./FreeForm"
import Text from "../../common/components/Text"
import SubmitButton from "./SubmitButton"
import OptionContainer from "./OptionContainer"
import Check from "../../completion/images/Check"
import { FormattedMessage } from "react-intl"

const HintText = Text.withComponent("div").extend.attrs({
  size: "bodySmall",
  color: "neutralDarkest",
})`
  text-align: right;
  margin: 0.3333rem 0;
  padding-bottom: 12px;
`
const OptionButtonContainer = styled.div`
  display: flex;
  align-items: center;
`

// Select some
const Checkbox = ({ item, editing, dispatch }) => (
  <div>
    <HintText>
      <FormattedMessage
        id="interview.questions.selectall"
        defaultMessage="Please mark all that apply"
      />
    </HintText>
    <OptionContainer>
      {item.options
        .filter(option => option.preselected == null)
        .map(option => {
          const selected =
            item.response.filter(x => x.token === option.token).length > 0
          return (
            <OptionButtonContainer key={option.token}>
              {selected && (
                <Check
                  margin="0 10px 0 0"
                  color="primary"
                  width="18px"
                  strokeWidth="1.5"
                  height="14px"
                />
              )}
              <OptionButton
                option={option}
                selected={selected}
                onClick={onResponse(item, dispatch)}
              />
            </OptionButtonContainer>
          )
        })}
    </OptionContainer>
    <TransitionGroup
      transitionName="freeform-text"
      component="div"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {item.options.map(option =>
        option.isfreetext &&
        item.response.filter(x => x.token === option.token).length > 0 ? (
          <FreeForm />
        ) : null
      )}
    </TransitionGroup>
    <QuestionReport showButton editing={editing} />
    <SubmitButton
      disabled={item.response.filter(r => !r.preselected).length === 0}
      count={item.response.filter(r => !r.preselected).length}
      onSubmit={onSubmit(item, dispatch)}
    />
  </div>
)

class CheckboxContainer extends React.Component {
  componentDidMount() {
    if (this.props.showMoreOptions) setTimeout(this.props.showMoreOptions, 1000)
  }

  componentWillUnmount() {
    if (this.props.hideMoreOptions) this.props.hideMoreOptions(false)
  }

  render() {
    return <Checkbox {...this.props} />
  }
}

export { CheckboxContainer as default }



// WEBPACK FOOTER //
// ./assets/interview/components/CheckboxResponse.js